import api from '../../ApiConfig';
import { Apis } from '../../config';
var token = localStorage.getItem('userToken');


const createMedia = async (data) => {
  try {
    let result = await api.post(Apis.CreateMedia, data, {
      headers: {
        'x-access-token': token,
        "Content-Type": "multipart/form-data",
      }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const createVideoMedia = async (data) => {
  try {
    let result = await api.post(Apis.CreateVideoMedia, data, {
      headers: {
        'x-access-token': token,
        "Content-Type": "multipart/form-data",
      }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const getAllMedia = async (currentPage, pageSize=24, search='') => {
  try {

    let result = await api.get(`${Apis.GetAllMedia}?page=${currentPage}&pageSize=${pageSize}&search=${search}`, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const getAllMediaShow = async () => {
  try {
    let result = await api.get(`${Apis.GetAllMediaShow}`, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};



const deleteMedia = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteMedia+id, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const deleteMultipleFiles = async (data) => {
  try {
    let result = await api.post(Apis.DeleteMultipleMedia, data, {
      headers: {
        'x-access-token': token
      }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const udpateMediaContent = async (id, data) => {
  try {
    const result = await api.put(Apis.UpdateMedia + id, data, {
      headers: {
        'x-access-token': token
      }
    });

    if (result.data.error) {
      return { success: false, message: result.data.message || "An error occurred" };
    }

    return { success: true, data: result.data };
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message || "An error occurred";

      if (status === 400) {
        return { success: false, message: "Bad Request: " + message };
      } else if (status === 404) {
        return { success: false, message: "Not Found: " + message };
      } else if (status === 500) {
        return { success: false, message: "Server Error: " + message };
      } else {
        return { success: false, message: `Error ${status}: ` + message };
      }
    }

    // Network or unexpected error
    return { success: false, message: "Network error or unexpected issue occurred." };
  }
};



const exportedObject = {
    getAllMedia,
    createMedia,
    deleteMedia,
    createVideoMedia,
    deleteMultipleFiles,
    getAllMediaShow,
    udpateMediaContent
};
export default exportedObject;